import { h, type Component } from 'vue'
import { Icon } from './index'
import { getAvailableIcons, type IconName } from './registry'

/**
 * Creates a Vue component wrapper for SVG icons that can be used
 * as a Component type (compatible with tools.ts icon property)
 * 
 * The Icon component now automatically detects whether to use fill or stroke
 * based on the SVG content, so no manual configuration is needed.
 */
export const createSvgIconComponent = (name: IconName): Component => {
  return {
    name: `SvgIcon_${name}`,
    setup(props) {
      return () => h(Icon, { name, ...props })
    }
  }
}

/**
 * Capitalizes the first letter and converts kebab-case to PascalCase
 */
const toPascalCase = (str: string): string => {
  return str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
}

/**
 * Dynamically generated icon components from the registry
 * This automatically stays in sync with the icon registry
 */
export const SvgIcons = getAvailableIcons().reduce((acc, iconName) => {
  const componentName = toPascalCase(iconName)
  acc[componentName] = createSvgIconComponent(iconName)
  return acc
}, {} as Record<string, Component>)